import './textSection.css';

const TextSection = (props) => {
  const { enum: section } = props;
  return (
    <section
      className="text-section"
      id={section.id ? section.id : undefined}
      aria-labelledby={section.id ? `${section.id}-headline` : undefined}
    >
      <br />
      <h2
        className="text-section-headline"
        id={section.id ? `${section.id}-headline` : undefined}
      >
        {section.name}
      </h2>

      {section.html}
    </section>
  );
};

export default TextSection;
